export const policies = {
  enableClinicalRulesEngine: "enable_clinical_rules_engine",
  enableWoundNumberView: "enable_wound_number_view",
  revisionComparisonViewEnabled: "revision_comparison_view_enabled",
  assessmentStateViewable: "assessment_state_viewable"
};
